export enum AuthenticationType {
    Velocity = 8
}
